let settingsKey = "";
let settingValue: any = {};

function init() {
    settingsKey = "ithome-mall-setting";
    settingValue = JSON.parse((window.localStorage.getItem(settingsKey)) || "{}");
}

init();

let userId: number;

const setUserId = (id: number)=>{
    userId = id;
}

function setItem(name: string, value: any, currentUserOnly?: boolean) {
    if (typeof name !== "string") {
        throw new Error('Parameter name must be a string!');
    }
    let key = name;
    if (currentUserOnly) {
        if (userId) {
            key = `${name}_user_${userId}`
        }
    }
    settingValue[key] = value;
    saveConfig()
}

function saveConfig() {
    window?.localStorage?.setItem(settingsKey, JSON.stringify(settingValue));
}

function getItem(name: string, defaultValue: any, currentUserOnly?: boolean) {
    if (typeof name !== "string") {
        throw new Error('Parameter name must be a string!');
    }
    init();
    let key = name;
    if (currentUserOnly) {
        if (userId) {
            key = `${name}_user_${userId}`
        }
    }
    if (typeof settingValue[key] !== typeof undefined) {
        return settingValue[key];
    }
    return defaultValue;
}

function deleteItem(name: string, currentUserOnly?: boolean) {
    if (typeof name !== "string") {
        throw new Error('Parameter name must be a string!');
    }
    init();
    let key = name;
    if (currentUserOnly) {
        if (userId) {
            key = `${name}_user_${userId}`
        }
    }
    if (typeof settingValue[key] !== typeof undefined) {
        delete settingValue[key]
    }
    saveConfig();
}

/**
 * 销毁本地存储
 * @param option retainKeys 要保留的key，prefix 是key的前缀
 */
function destory(option?: { retainKeys?: { key: string, prefix: boolean }[] }) {
    if (option?.retainKeys && option?.retainKeys?.length > 0) {
        init();
        const newData = JSON.parse((window.localStorage.getItem(settingsKey)) || "{}");
        Object.keys(newData).slice(0).forEach((key) => {
            const needKeep = !!option?.retainKeys?.find((i) => { return i.key === key || (i.prefix && key.startsWith(i.key)) });
            if (!needKeep) {
                delete newData[key];
            }
        })
        window?.localStorage?.setItem(settingsKey, JSON.stringify(newData))
    } else {
        window?.localStorage?.removeItem(settingsKey)
    }

}
export default {
    getItem,
    deleteItem,
    setItem,
    destory,
    setUserId
}